import React, { useState, useEffect } from "react";
import CollegesComp from "./programsComp/CollegesComp";
import { storage, db } from "../firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { getDownloadURL, ref } from "firebase/storage";

function Programs(props) {
  const officesRef = collection(db, "offices");
  const programsRef = collection(db, "programs");
  let coverRef = ref(storage, "files/images/dp.jpg");

  const [coverUrl, setCoverUrl] = useState(
    "http://localhost:3000/static/media/logo.bbd43f561d3fc0429b9e.png"
  );
  const [offices, setOffices] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [officesRender, setOfficesRender] = useState([
    {
      idOffice: 0,
      name: "Loading",
      shortName: "",
      logoUrl: "",
      departments: [{ name: "loading" }],
    },
  ]);

  let officesLoad = [];
  let programsLoad = [];

  const getOffices = async () => {
    const data = await getDocs(officesRef);
    officesLoad = data.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }))
      .sort((a, b) => {
        let da = a.idOffice;
        let db = b.idOffice;
        return da - db;
      });
    setOffices(officesLoad);
  };

  const getPrograms = async () => {
    const data = await getDocs(programsRef);
    programsLoad = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    setPrograms(programsLoad);
  };

  const arrangeOfficePrograms = () => {
    let officesNew = [];

    officesLoad.forEach((val) => {
      let officeTemp = {
        idOffice: parseInt(val.idOffice),
        name: val.name,
        shortName: val.shortName,
        logoUrl: val.logoUrl,
        departments: [],
      };

      programsLoad.forEach((val2) => {
        if (val2.idOffice == val.idOffice) {
          officeTemp.departments.push(val2);
        }
      });

      officesNew.push(officeTemp);
    });

    setOfficesRender(officesNew);
  };

  useEffect(() => {
    document.title = "PEACI - Programs";
    getOffices();
    getPrograms().then(() => {
      arrangeOfficePrograms();
    });
    props.setActivePage();
    getDownloadURL(coverRef).then((res) => {
      setCoverUrl(res);
    });

    // eslint-disable-next-line
  }, []);
  return (
    <div className="flex flex-col items-center w-screen z-10 py-10">
      {/* Hero — cover image with gradient overlay and page title */}
      <div className="relative w-full h-[360px] md:h-[440px] overflow-hidden">
        <img
          className="absolute inset-0 w-full h-full object-cover object-center"
          src={coverUrl}
          alt="PEACI campus"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-stone-900/70 via-stone-900/50 to-stone-900/80" />
        <div className="relative flex flex-col items-center justify-center h-full gap-3 px-6 text-center">
          <span className="inline-block px-4 py-1 rounded-full bg-sky-500/20 border border-sky-400/40 text-sky-300 text-xs font-semibold tracking-widest uppercase">
            Academic Excellence
          </span>
          <h1 className="text-5xl md:text-7xl font-extrabold tracking-tight text-white drop-shadow-lg">
            PROGRAMS
          </h1>
          <p className="text-stone-300 text-sm md:text-base max-w-md">
            Quality education tailored to meet competitive global standards.
          </p>
        </div>
      </div>

      {/* Intro / stat band */}
      <div className="w-full bg-white border-b border-stone-200">
        <div className="max-w-4xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center gap-8">
          <p className="flex-1 text-stone-600 text-base md:text-lg leading-relaxed text-center md:text-left">
            PEACI offers the quality education needed by the students to meet
            the competitive global standards. The institution has 11
            undergraduate programs which they could choose to suit their
            individual talents and passion.
          </p>
          <div className="flex gap-6 flex-shrink-0">
            <div className="flex flex-col items-center px-6 py-4 rounded-2xl bg-sky-50 border border-sky-100">
              <span className="text-4xl font-extrabold text-sky-600">11</span>
              <span className="text-xs text-stone-500 font-medium mt-1 text-center leading-tight">
                Undergraduate<br />Programs
              </span>
            </div>
            <div className="flex flex-col items-center px-6 py-4 rounded-2xl bg-stone-50 border border-stone-200">
              <span className="text-4xl font-extrabold text-stone-700">
                {officesRender.filter((o) => o.name !== "Loading").length - 1 || "—"}
              </span>
              <span className="text-xs text-stone-500 font-medium mt-1 text-center leading-tight">
                Colleges /<br />Institutes
              </span>
            </div>
          </div>
        </div>
      </div>

      {officesRender.map((val, key) => {
        return <CollegesComp key={key} index={key} data={val} />;
      })}
    </div>
  );
}

export default Programs;
